import styled from "styled-components";

export const Container = styled.div<{ scale: number; backgroundImage: string }>`
	font-size: 17px;
	width: 21.375em;
	height: 36.0625em;
	background-color: #fffaf1;
	border-radius: 16px;
	overflow: hidden;
	transform: scale(${(props) => props.scale});
	display: flex;
	flex-direction: column;
	align-items: center;

	@media (orientation: landscape) {
		font-size: 16px;
		width: 59.75em;
		height: 25.625em;
	}
`;

export const Body = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	flex-direction: column;
	width: 90%;
	height: 100%;
	gap: 1.7em;
	padding-top: 1.6em;

	@media (orientation: landscape) {
		width: 95%;
	}
`;

export const Title = styled.div`
	color: #113b62;
	text-align: center;
	font-family: Baloo;
	font-size: 2.125em;
	font-style: normal;
	font-weight: 400;
	line-height: 0.85em;

	@media (orientation: landscape) {
		font-size: 3.25em;
	}
`;

export const StepsContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1em;

	@media (orientation: landscape) {
		flex-direction: row;
	}
`;

export const Step = styled.div`
	border-radius: 16px;
	background: #fff;
	box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.15);
	padding: 0.563em;
	padding-left: 0.81em;
	gap: 1em;
	display: flex;
	height: 7em;

	@media (orientation: landscape) {
		height: 14em;
	}
`;

export const StepInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;

	@media (orientation: landscape) {
		align-items: center;
	}
`;

export const StepTitle = styled.div`
	color: #113b62;
	font-family: Baloo;
	font-size: 1.625em;
	font-style: normal;
	font-weight: 400;

	@media (orientation: landscape) {
		width: 100%;
		text-align: left;
		line-height: 1em;
	}
`;

export const StepDescription = styled.div`
	color: #333;
	font-family: Inter;
	font-size: 1em;
	font-style: normal;
	font-weight: 500;

	@media (orientation: landscape) {
		//width: 100%;
		padding: 0.8em;
		text-align: center;
	}
`;

export const StepImageWrapper = styled.div`
	width: 7em;
	height: 7em;
	flex-shrink: 0;
	background-color: #f5f5f5;
	border-radius: 12px;
	overflow: hidden;

	@media (orientation: landscape) {
		width: 8.125em;
		height: 8.125em;
	}
`;

export const StepImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
	display: block;
	text-align: center;
`;
